import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {performSignedFileQuery} from 'external-files/ExternalFileUtils';
import Chip, {ChipSize} from 'ui-library/chips/Chip';

import {ScratchFileContent} from './ScratchFileTypes';

export async function openScratchFileInNewTab(scratchFile: ScratchFileContent): Promise<void> {
  const signedURL = await performSignedFileQuery(
    scratchFile.externalFileId!,
    scratchFile.downloadUrl!,
    scratchFile.id
  );
  if (signedURL == null) {
    return;
  }
  window.open(signedURL, '_blank', 'noopener noreferrer');
}

interface ScratchFileChipProps {
  scratchFile: ScratchFileContent;
  size?: ChipSize;
  /** Replaces the default click behavior of opening the file in a new tab. */
  onClick?: () => void;
}

export default function ScratchFileChip({
  scratchFile,
  size = ChipSize.SMALL,
  onClick,
}: ScratchFileChipProps): JSX.Element {
  async function handleClick(): Promise<void> {
    await openScratchFileInNewTab(scratchFile);
  }

  return (
    <Chip
      className="chip-container"
      icon={ModelTypeConstants.EXTERNAL_FILE}
      onClick={onClick ?? handleClick}
      size={size}
      text={scratchFile.filename}
    />
  );
}
